import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  Boxes,
  Users,
  BarChart3,
  UserCog,
  ScrollText,
  Building2,
  type LucideIcon,
} from "lucide-react";
import type { Permission } from "./permissions";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  permission: Permission;
  /** Additionally requires the BOOTSTRAP_SUPER admin level (JWT claim). */
  bootstrapOnly?: boolean;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

// Single source of truth for the admin sidebar. Each item declares the permission
// required to see it; the Shell filters by the current role so no one is shown a
// door they can't open. Sections render only when they have at least one visible item.
export const NAV_SECTIONS: NavSection[] = [
  {
    title: "Overview",
    items: [
      { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, permission: "dashboard.view" },
    ],
  },
  {
    title: "Commerce",
    items: [
      { to: "/orders", label: "Orders", icon: ShoppingCart, permission: "orders.manage" },
      { to: "/catalog", label: "Catalog", icon: Package, permission: "catalog.manage" },
      { to: "/inventory", label: "Inventory", icon: Boxes, permission: "inventory.manage" },
      { to: "/customers", label: "Customers", icon: Users, permission: "customers.manage" },
    ],
  },
  {
    title: "Insights",
    items: [
      { to: "/analytics", label: "Analytics", icon: BarChart3, permission: "analytics.view" },
    ],
  },
  {
    title: "Administration",
    items: [
      { to: "/staff", label: "Staff Registry", icon: UserCog, permission: "staff.manage" },
      {
        to: "/tenants",
        label: "Tenants",
        icon: Building2,
        permission: "staff.manage",
        bootstrapOnly: true,
      },
      { to: "/audit", label: "Security Audit", icon: ScrollText, permission: "audit.view" },
    ],
  },
];
